import { render } from "./BestSeller.vue?vue&type=template&id=06494774&scoped=true"
import script from "./BestSeller.vue?vue&type=script&lang=js"
export * from "./BestSeller.vue?vue&type=script&lang=js"

import "./BestSeller.vue?vue&type=style&index=0&id=06494774&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06494774"]])

export default __exports__